const trustedKeyID = 'b0587090f66a7cf5'
const trustedPublicKey = 'EDdIWX46mwaiWBXjKSTOevnFKVu88KL8ZVwXEL9ikKw='

type Envelope = { algorithm: string; keyID: string; payload: string; signature: string }
type Presentation = { featuredAct?: number | string | null }
type Payload = { expiresAt: string; presentation?: Presentation }

function bytes(value: string) {
  return Uint8Array.from(atob(value), (character) => character.charCodeAt(0))
}

export async function loadFeaturedAct(): Promise<number | null> {
  try {
    const response = await fetch('/live-config/v1/config.json', { cache: 'no-cache', credentials: 'omit' })
    if (!response.ok) return null
    const envelope = await response.json() as Envelope
    if (envelope.algorithm !== 'ed25519' || envelope.keyID !== trustedKeyID) return null
    const key = await crypto.subtle.importKey('raw', bytes(trustedPublicKey), { name: 'Ed25519' }, false, ['verify'])
    const payloadBytes = bytes(envelope.payload)
    if (!await crypto.subtle.verify('Ed25519', key, bytes(envelope.signature), payloadBytes)) return null
    const payload = JSON.parse(new TextDecoder().decode(payloadBytes)) as Payload
    if (Date.parse(payload.expiresAt) <= Date.now()) return null
    const featured = payload.presentation?.featuredAct
    // Remote configuration shares the game's player-facing 1...4 act numbers;
    // React arrays use zero-based indices.
    if (typeof featured === 'number' && Number.isInteger(featured) && featured >= 1 && featured <= 4) return featured - 1
    if (typeof featured === 'string') {
      const index = ['strongflea', 'juggler', 'trapeze', 'cannon'].indexOf(featured.toLowerCase())
      return index >= 0 ? index : null
    }
  } catch { /* Built-in ordering remains the safe fallback. */ }
  return null
}
